import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  fetchTours,
  createTour,
  deactivateTour,
  safeDeleteTour,
  updateTour,
  fetchTourCategories,
} from '../../services/tours'
import { toast } from 'react-toastify';


export const getTours = createAsyncThunk(
  'tours/fetchTours',
  async (thunkAPI) => {
    try {
      const res = await fetchTours()

      return res.data || []
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  },
)

export const getTourCategories = createAsyncThunk(
  'tours/fetchTourCategories',
  async (_, thunkAPI) => {
    try {
      const res = await fetchTourCategories()
      return res.data || []
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  },
)

export const addTour = createAsyncThunk(
  'tours/addTour',
  async (data, thunkAPI) => {
    try {
      // const res = await createTour(data)
      const res = await toast.promise(
        createTour(data).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se registró correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      if (res.error) {
        return thunkAPI.rejectWithValue({ error: res.error.message })
      }

      if (!res.data || res.data.length === 0) {
        return thunkAPI.rejectWithValue({ error: "No se pudo registrar el tour" })
      }

      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)


/**
 * Phase 1 — Check if deletion is safe, or get info about blocking reservations.
 * Returns a SafeDeleteResult so the UI can decide: show deactivate/force options.
 */
export const removeTour = createAsyncThunk(
  'tours/removeTour',
  async (id, thunkAPI) => {
    const result = await safeDeleteTour(id, false);
    if (result.success) {
      // No reservations — tour was deleted cleanly
      toast.success('Tour eliminado correctamente 🗑️');
      return { id, deleted: true };
    }
    if (result.blocked) {
      // Return the info so the UI can show the conflict modal
      return thunkAPI.fulfillWithValue({ id, blocked: true, ...result });
    }
    // Unexpected error
    toast.error(result.error || 'Error al eliminar el tour');
    return thunkAPI.rejectWithValue({ error: result.error });
  }
)

/** Phase 2a — Soft delete (safe): hides the tour from the catalog, preserves reservation history */
export const deactivateTourThunk = createAsyncThunk(
  'tours/deactivateTour',
  async (id, thunkAPI) => {
    try {
      const { error } = await deactivateTour(id);
      if (error) throw error;
      toast.success('Tour desactivado. No aparecerá en el catálogo.');
      return id;
    } catch (err) {
      toast.error('Error al desactivar el tour');
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
)

/** Phase 2b — Force delete: removes reservations_tours references first, then deletes the tour */
export const forceDeleteTour = createAsyncThunk(
  'tours/forceDeleteTour',
  async (id, thunkAPI) => {
    const result = await safeDeleteTour(id, true);
    if (result.success) {
      toast.success(
        result.reservations_removed
          ? `Tour eliminado. Se desviculó de ${result.reservations_removed} reserva(s).`
          : 'Tour eliminado correctamente.'
      );
      return { id, deleted: true };
    }
    toast.error(result.error || 'Error al eliminar el tour');
    return thunkAPI.rejectWithValue({ error: result.error });
  }
)

export const editTour = createAsyncThunk(
  'tours/editTour',
  async ({ id, ...tour }, thunkAPI) => {
    try {

      const res = await toast.promise(
        updateTour(id, tour).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se actualizó correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      if (res.error) {
        return thunkAPI.rejectWithValue({ error: res.error.message })
      }

      if (!res.data || res.data.length === 0) {
        return thunkAPI.rejectWithValue({ error: "No se pudo actualizar el tour" })
      }

      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)
